import { calculateMinimumSelectedDays } from 'ha/utils/exclusionDate';

const getEarliestBookingStartDate = (startDate, minimumDate) =>
  startDate || minimumDate;

export default (startDate, minimalPeriod, minimumDate) =>
  calculateMinimumSelectedDays(
    startDate || getEarliestBookingStartDate(startDate, minimumDate),
    minimalPeriod,
  );
